// import React, { useEffect, useState } from "react";
// import Header from "../../../../CommonComponents/header";
// import { Footer } from "../../../../CommonComponents/footer";
// import { ProductCategoryHeroSection } from "../../Components/productCategoryHeroSection";
// import { RightImagesTextcard } from "../../Components/rightImageTextCard";
// import { LeftImagesTextCard } from "../../Components/leftImagesTextcard";
// import { WhyProductCategorySection } from "../../Components/whyProductCategorysection";
// import { MobileHeader } from "../../../../CommonComponents/mobileHeader";
// import { useParams } from "react-router-dom";
// import { baseurl } from "../../../../CommonComponents/baseurl";
// import { useDispatch } from "react-redux";
// import { allSlugData, setProgress } from "../../../../Redux/ReduxFunction";
// import NotFoundComp from "../../../../CommonComponents/notFoundComp";
// import { MainHeading } from "../../../../subComponents/MainHeading";

// const HomeInterior = () => {
//   const [currentcategory, setCurrentcategory] = useState([]);
//   const [subcategorylist, setSubcategorylist] = useState([]);
//   const [isDataLoad, setIsDataLoad] = useState(false);

//   const { slug } = useParams();

//   var dispatch = useDispatch();

//   useEffect(() => {
//     dispatch(allSlugData("data"));
//     const fetchCategory = async () => {
//       console.log(slug, "hello world");

//       if (!slug) return;
//       try {
//         const formData = new FormData();
//         formData.append("slug", slug);

//         const response = await fetch(`${baseurl}/api/sub-category`, {
//           method: "POST",
//           body: formData,
//         });

//         const data = await response.json();
//         // console.log("Fetched data:", data);
//         if (data.success === "1") {
//           setCurrentcategory(data);
//           setSubcategorylist(data.data);
//           dispatch(setProgress(data.meta_title));
//         } else {
//           console.error("Failed to fetch data:", data.message);
//         }

//         if (data.success === "6") {
//           setIsDataLoad(true);
//         }
//       } catch (error) {
//         console.error("Error fetching data:", error);
//       }
//     };

//     fetchCategory();
//   // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [slug]);

//   useEffect(() => {
//     // console.log("Category state updated:", currentcategory);
//   }, [currentcategory]);

//   return (
//     <>
//       <Header />
//       <MobileHeader />

//       <div className="desktop_header_spacer"></div>

//       {isDataLoad ? (
//         <NotFoundComp />
//       ) : (
//         <>
//           <ProductCategoryHeroSection
//             title={currentcategory.page_title}
//             content={currentcategory.page_description}
//             show={false}
//             showinterior={true}
//             subcategorylist={subcategorylist}
//             categoryslug={currentcategory.slug}
//             bannerImage={currentcategory.page_banner ?? null}
//           />

//           {slug === "extrusion-manufacturing" ? (
//             <>
//               <WhyProductCategorySection
//                 title={"Why we use Metal Tubes?"}
//                 content={<>
//                 Lorem ipsum dolor sit, amet consectetur adipisicing elit. Alias asperiores iste vitae non porro soluta odio natus aliquam. Quasi maxime facere libero iure, repellat ratione soluta ab mollitia at quisquam aliquam reprehenderit praesentium nostrum perferendis sit, architecto magnam? Nemo ad deserunt dolores aut error iure molestias quae quisquam, voluptates, similique suscipit? Nesciunt facere quia, ex in cumque alias laudantium! Rem accusamus omnis tempore sunt maxime incidunt reiciendis totam est alias consectetur nihil, fugiat provident quas repellendus. Facere eligendi sapiente est voluptate quo perferendis dolorum velit voluptatibus magni voluptatem amet reiciendis, necessitatibus ab, accusantium dolore quae sed. Nesciunt deleniti exercitationem accusamus, fugit voluptas earum ab, necessitatibus quo minus atque sint, consectetur impedit odit quae commodi expedita numquam. Facere voluptate numquam quisquam!
//                 </>}
//                 imageurl={"/assets/images/new_images/blogs/blog2.webp"}
//               />

//               <section className="upvc_benefit_section">
//                 <div
//                   style={{
//                     width: "max-content",
//                     margin: "auto",
//                     padding: "2rem 0",
//                   }}
//                 >
//                   <MainHeading title={"Benefits of Metal Tubes"} />
//                 </div>

//                 <RightImagesTextcard
//                   orangeheading={"Superior Insulation"}
//                   title=" - and Energy Efficiency"
//                   content={
//                     <>
//                     Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus commodi quibusdam mollitia dolor doloribus? Molestiae vero cupiditate praesentium alias vitae animi soluta quae ipsa voluptatibus architecto saepe eius nostrum error incidunt eaque, ex recusandae aut sit? Accusamus ex recusandae sapiente veniam? Suscipit similique provident blanditiis velit magnam, ut delectus rem quia dolorem, quam et? Placeat fugit tempora nisi dolorum quis quas maxime eius quae, perferendis suscipit magnam reiciendis vero natus at facilis tempore quod ipsum quia praesentium a laboriosam ipsa temporibus optio? Quo asperiores voluptates sapiente explicabo nemo tenetur, deserunt, facilis laborum obcaecati magni neque voluptatibus nisi animi itaque quidem.
//                     </>
//                   }
//                   imageurl={"/assets/images/new_images/blogs/blog5.jpg"}
//                 />
//                 <LeftImagesTextCard
//                   orangeheading={"Low Maintenance"}
//                   title={"and Durability"}
//                   content={
//                     <>
//                     Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus commodi quibusdam mollitia dolor doloribus? Molestiae vero cupiditate praesentium alias vitae animi soluta quae ipsa voluptatibus architecto saepe eius nostrum error incidunt eaque, ex recusandae aut sit? Accusamus ex recusandae sapiente veniam? Suscipit similique provident blanditiis velit magnam, ut delectus rem quia dolorem, quam et? Placeat fugit tempora nisi dolorum quis quas maxime eius quae, perferendis suscipit magnam reiciendis vero natus at facilis tempore quod ipsum quia praesentium a laboriosam ipsa temporibus optio? Quo asperiores voluptates sapiente explicabo nemo tenetur, deserunt, facilis laborum obcaecati magni neque voluptatibus nisi animi itaque quidem.
//                     </>                  }
//                   imageurl={"/assets/images/new_images/blogs/blog4.jpg"}
//                 />
//                 <RightImagesTextcard
//                   orangeheading={"Enhanced"}
//                   title=" - Security and Safety"
//                   content={
//                     <>
//                     Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus commodi quibusdam mollitia dolor doloribus? Molestiae vero cupiditate praesentium alias vitae animi soluta quae ipsa voluptatibus architecto saepe eius nostrum error incidunt eaque, ex recusandae aut sit? Accusamus ex recusandae sapiente veniam? Suscipit similique provident blanditiis velit magnam, ut delectus rem quia dolorem, quam et? Placeat fugit tempora nisi dolorum quis quas maxime eius quae, perferendis suscipit magnam reiciendis vero natus at facilis tempore quod ipsum quia praesentium a laboriosam ipsa temporibus optio? Quo asperiores voluptates sapiente explicabo nemo tenetur, deserunt, facilis laborum obcaecati magni neque voluptatibus nisi animi itaque quidem.
//                     </>                  }
//                   imageurl={"/assets/images/new_images/blogs/blog3.jpg"}
//                 />
//                 <LeftImagesTextCard
//                   orangeheading={"Cost-Effective"}
//                   title={"and Affordable"}
//                   content={
//                     <>
//                     Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ducimus commodi quibusdam mollitia dolor doloribus? Molestiae vero cupiditate praesentium alias vitae animi soluta quae ipsa voluptatibus architecto saepe eius nostrum error incidunt eaque, ex recusandae aut sit? Accusamus ex recusandae sapiente veniam? Suscipit similique provident blanditiis velit magnam, ut delectus rem quia dolorem, quam et? Placeat fugit tempora nisi dolorum quis quas maxime eius quae, perferendis suscipit magnam reiciendis vero natus at facilis tempore quod ipsum quia praesentium a laboriosam ipsa temporibus optio? Quo asperiores voluptates sapiente explicabo nemo tenetur, deserunt, facilis laborum obcaecati magni neque voluptatibus nisi animi itaque quidem.
//                     </>                  }
//                   imageurl={"/assets/images/new_images/blogs/blog1.jpg"}
//                 />
//               </section>
//             </>
//           ) : (
//             ""
//           )}

//           {slug === "metal-tube-bending-and-assy" ? (
//             <>
//               <WhyProductCategorySection
//                 title={"Why we use Nylon Tube Assemblies?"}
//                 content={<>
//                 Lorem ipsum dolor sit amet consectetur adipisicing elit. Ratione debitis doloribus incidunt quasi distinctio impedit pariatur sit provident minima iste suscipit cumque hic eligendi architecto quidem, vero ipsa esse maiores omnis, repudiandae, nemo soluta tenetur voluptatum nihil? Totam, sequi. Unde aliquid distinctio sint id corrupti qui facere pariatur omnis laborum maiores, illo tempore. Quasi temporibus harum officia tempora similique rem magni labore ipsam pariatur, eius quidem odit, assumenda nostrum minus enim hic. Suscipit accusamus non velit, vero, dolorem eius ea consequuntur, hic voluptatibus quod iure ipsa cupiditate id saepe aperiam ad quibusdam provident ex odio. Ut repellendus ducimus voluptas similique quam tempora beatae cupiditate suscipit saepe? Iure architecto eos voluptatum blanditiis ad dolores distinctio modi cumque? Velit eum eos saepe.
//                 </>}
//                 imageurl={"/assets/images/new_images/recent_project/industrial-metal-drill-machine-metalworking-workshop_342744-520.jpg"}
//               />
//               <div
//                 style={{
//                   margin: "auto",
//                   padding: "2rem 0",
//                   textAlign: "center",
//                 }}
//               >
//                 <MainHeading title={"Benefits of Nylon Tube Assemblies"} />
//               </div>
//               <RightImagesTextcard
//                 orangeheading="Stylish"
//                 title=" - Aluminum"
//                 content={
//                   <>
//                   Lorem ipsum dolor sit amet consectetur, adipisicing elit. Distinctio voluptatibus molestias officiis soluta ratione dicta corporis omnis dolore rerum cupiditate praesentium tempora, vitae doloremque illum numquam sit laboriosam neque sunt non aut consequuntur quis. Excepturi, delectus exercitationem nulla esse distinctio ad. Exercitationem unde blanditiis minima voluptatum hic at quisquam. Aut id dolore amet velit enim expedita, similique animi exercitationem quam dolor corporis. Unde esse adipisci magni officia recusandae similique incidunt error, sed a facilis dignissimos cumque accusantium repellat autem totam aspernatur perferendis id minima quod optio illo? Inventore, aliquam in sit sapiente, consequatur, exercitationem doloribus ea veniam perspiciatis temporibus ex?
//                   </>
//                 }
//                 imageurl={
//                   "/assets/images/new_images/recent_project/istockphoto-457740707-612x612.jpg"
//                 }
//               />
//               <LeftImagesTextCard
//                 orangeheading={"Customized"}
//                 title={"Interior Fit-Outs Available"}
//                 content={
//                   <>
//                   Lorem ipsum dolor sit amet consectetur, adipisicing elit. Distinctio voluptatibus molestias officiis soluta ratione dicta corporis omnis dolore rerum cupiditate praesentium tempora, vitae doloremque illum numquam sit laboriosam neque sunt non aut consequuntur quis. Excepturi, delectus exercitationem nulla esse distinctio ad. Exercitationem unde blanditiis minima voluptatum hic at quisquam. Aut id dolore amet velit enim expedita, similique animi exercitationem quam dolor corporis. Unde esse adipisci magni officia recusandae similique incidunt error, sed a facilis dignissimos cumque accusantium repellat autem totam aspernatur perferendis id minima quod optio illo? Inventore, aliquam in sit sapiente, consequatur, exercitationem doloribus ea veniam perspiciatis temporibus ex?
//                   </>                }
//                 imageurl={
//                   "/assets/images/new_images/recent_project/harvesters-combine-parts-plant-are-waiting-sales_146671-19060.jpg"
//                 }
//               />
//               <RightImagesTextcard
//                 orangeheading={"Green"}
//                 title=" - Solutions"
//                 content={
//                   <>
//                   Lorem ipsum dolor sit amet consectetur, adipisicing elit. Distinctio voluptatibus molestias officiis soluta ratione dicta corporis omnis dolore rerum cupiditate praesentium tempora, vitae doloremque illum numquam sit laboriosam neque sunt non aut consequuntur quis. Excepturi, delectus exercitationem nulla esse distinctio ad. Exercitationem unde blanditiis minima voluptatum hic at quisquam. Aut id dolore amet velit enim expedita, similique animi exercitationem quam dolor corporis. Unde esse adipisci magni officia recusandae similique incidunt error, sed a facilis dignissimos cumque accusantium repellat autem totam aspernatur perferendis id minima quod optio illo? Inventore, aliquam in sit sapiente, consequatur, exercitationem doloribus ea veniam perspiciatis temporibus ex?
//                   </>                }
//                 imageurl={
//                   "/assets/images/new_images/recent_project/industrial-metal-drill-machine-metalworking-workshop_342744-520.jpg"
//                 }
//               />
//               <LeftImagesTextCard
//                 orangeheading={"Long-Lasting"}
//                 title={"Durability and Strength"}
//                 content={
//                   <>
//                   Lorem ipsum dolor sit amet consectetur, adipisicing elit. Distinctio voluptatibus molestias officiis soluta ratione dicta corporis omnis dolore rerum cupiditate praesentium tempora, vitae doloremque illum numquam sit laboriosam neque sunt non aut consequuntur quis. Excepturi, delectus exercitationem nulla esse distinctio ad. Exercitationem unde blanditiis minima voluptatum hic at quisquam. Aut id dolore amet velit enim expedita, similique animi exercitationem quam dolor corporis. Unde esse adipisci magni officia recusandae similique incidunt error, sed a facilis dignissimos cumque accusantium repellat autem totam aspernatur perferendis id minima quod optio illo? Inventore, aliquam in sit sapiente, consequatur, exercitationem doloribus ea veniam perspiciatis temporibus ex?
//                   </>                }
//                 imageurl={
//                   "/assets/images/new_images/recent_project/download.jpeg"
//                 }
//               />
//             </>
//           ) : (
//             ""
//           )}

//           {slug === "others" ? (
//             <>
//               <WhyProductCategorySection
//                 title={"Why we use Manufacturing?"}
//                 content={<>
//                 Lorem ipsum dolor sit amet consectetur adipisicing elit. Eaque reiciendis odit nemo commodi deserunt dolorum similique accusantium, ad praesentium est facere placeat aperiam rem in et nulla magni maxime voluptatem officia! Excepturi sunt ea sapiente necessitatibus, cumque explicabo. Incidunt magni minus quidem numquam. Unde facilis magnam soluta repellat blanditiis eum totam nisi ducimus, alias harum nobis, dolore quia illo possimus suscipit, sunt laudantium ipsam recusandae similique impedit reiciendis temporibus culpa quo. Nam, laborum. Voluptates, consequuntur rem! Quas itaque dolorem laboriosam voluptates suscipit reprehenderit atque numquam in, iste optio mollitia! Earum non odit nobis provident repellat laborum deleniti quasi illo cupiditate?
//                 </>}
//                 imageurl={
//                   "/assets/images/new_images/blogs/blog5.jpg"
//                 }
//               />
//               <div
//                 style={{
//                   margin: "auto",
//                   padding: "2rem 0",
//                   textAlign: "center",
//                 }}
//               >
//                 <MainHeading title={"Benefits of Manufacturing"} />
//               </div>
//               <RightImagesTextcard
//                 orangeheading={"Cost-Effective"}
//                 title=" - and Easy Installation"
//                 content={
//                   <>
//                   Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quia, ex! Animi fuga sint ea accusantium error, maiores nihil quas. Rem laboriosam praesentium tenetur, pariatur nisi est itaque eum eius natus, reprehenderit voluptatum in architecto tempore dolore sint illo animi sapiente provident! Alias iste laudantium impedit repudiandae, amet quis, nesciunt explicabo nostrum ab eum a doloribus veniam sint, aliquam ad pariatur harum? Harum reprehenderit cumque laudantium debitis aliquid necessitatibus quae ea aperiam asperiores! Laboriosam maiores, aliquid placeat esse veritatis veniam perferendis!
//                   </>
//                 }
//                 imageurl={
//                   "/assets/images/new_images/blogs/blog1.jpg"
//                 }
//               />
//               <LeftImagesTextCard
//                 orangeheading={"Flexible"}
//                 title={"Space Management Solutions"}
//                 content={
//                   <>
//                   Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quia, ex! Animi fuga sint ea accusantium error, maiores nihil quas. Rem laboriosam praesentium tenetur, pariatur nisi est itaque eum eius natus, reprehenderit voluptatum in architecto tempore dolore sint illo animi sapiente provident! Alias iste laudantium impedit repudiandae, amet quis, nesciunt explicabo nostrum ab eum a doloribus veniam sint, aliquam ad pariatur harum? Harum reprehenderit cumque laudantium debitis aliquid necessitatibus quae ea aperiam asperiores! Laboriosam maiores, aliquid placeat esse veritatis veniam perferendis!
//                   </>                }
//                 imageurl={
//                   "/assets/images/new_images/blogs/blog2.webp"
//                 }
//               />
//               <RightImagesTextcard
//                 orangeheading={"Enhanced"}
//                 title=" - Privacy and Soundproofing"
//                 content={
//                   <>
//                   Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quia, ex! Animi fuga sint ea accusantium error, maiores nihil quas. Rem laboriosam praesentium tenetur, pariatur nisi est itaque eum eius natus, reprehenderit voluptatum in architecto tempore dolore sint illo animi sapiente provident! Alias iste laudantium impedit repudiandae, amet quis, nesciunt explicabo nostrum ab eum a doloribus veniam sint, aliquam ad pariatur harum? Harum reprehenderit cumque laudantium debitis aliquid necessitatibus quae ea aperiam asperiores! Laboriosam maiores, aliquid placeat esse veritatis veniam perferendis!
//                   </>                }
//                 imageurl={
//                   "/assets/images/new_images/blogs/blog3.jpg"
//                 }
//               />
//               <LeftImagesTextCard
//                 orangeheading={"Aesthetic"}
//                 title={"and Professional Design"}
//                 content={
//                   <>
//                   Lorem ipsum dolor, sit amet consectetur adipisicing elit. Quia, ex! Animi fuga sint ea accusantium error, maiores nihil quas. Rem laboriosam praesentium tenetur, pariatur nisi est itaque eum eius natus, reprehenderit voluptatum in architecto tempore dolore sint illo animi sapiente provident! Alias iste laudantium impedit repudiandae, amet quis, nesciunt explicabo nostrum ab eum a doloribus veniam sint, aliquam ad pariatur harum? Harum reprehenderit cumque laudantium debitis aliquid necessitatibus quae ea aperiam asperiores! Laboriosam maiores, aliquid placeat esse veritatis veniam perferendis!
//                   </>                }
//                 imageurl={
//                   "/assets/images/new_images/blogs/blog4.jpg"
//                 }
//               />
//             </>
//           ) : (
//             ""
//           )}

//           <div style={{ height: "3rem" }}></div>
//         </>
//       )}

//       <Footer />
//     </>
//   );
// };
// export { HomeInterior };

import React, { useEffect, useState } from "react";
import Header from "../../../../CommonComponents/header";
import { Footer } from "../../../../CommonComponents/footer";
import { ProductCategoryHeroSection } from "../../Components/productCategoryHeroSection";
import { RightImagesTextcard } from "../../Components/rightImageTextCard";
import { LeftImagesTextCard } from "../../Components/leftImagesTextcard";
import { WhyProductCategorySection } from "../../Components/whyProductCategorysection";
import { MobileHeader } from "../../../../CommonComponents/mobileHeader";
import { useParams } from "react-router-dom";
import { baseurl } from "../../../../CommonComponents/baseurl";
import { useDispatch } from "react-redux";
import { allSlugData, setProgress } from "../../../../Redux/ReduxFunction";
import NotFoundComp from "../../../../CommonComponents/notFoundComp";
import { MainHeading } from "../../../../subComponents/MainHeading";

const HomeInterior = () => {
  const [currentcategory, setCurrentcategory] = useState([]);
  const [subcategorylist, setSubcategorylist] = useState([]);
  const [isDataLoad, setIsDataLoad] = useState(false);

  const { slug } = useParams();

  var dispatch = useDispatch();

  useEffect(() => {
    dispatch(allSlugData("data"));
    const fetchCategory = async () => {
      console.log(slug, "hello world");

      if (!slug) return;
      try {
        const formData = new FormData();
        formData.append("slug", slug);

        const response = await fetch(`${baseurl}/api/sub-category`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        // console.log("Fetched data:", data);
        if (data.success === "1") {
          setCurrentcategory(data);
          setSubcategorylist(data.data);
          dispatch(setProgress(data.meta_title));
        } else {
          console.error("Failed to fetch data:", data.message);
        }

        if (data.success === "6") {
          setIsDataLoad(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  useEffect(() => {
    // console.log("Category state updated:", currentcategory);
  }, [currentcategory]);

  return (
    <>
      <Header />
      <MobileHeader />

      <div className="desktop_header_spacer"></div>

      {isDataLoad ? (
        <NotFoundComp />
      ) : (
        <>
          <ProductCategoryHeroSection
            title={currentcategory.page_title}
            content={currentcategory.page_description}
            show={false}
            showinterior={true}
            subcategorylist={subcategorylist}
            categoryslug={currentcategory.slug}
            bannerImage={currentcategory.page_banner ?? null}
          />

          {slug === "extrusion-manufacturing" ? (
            <>
              <WhyProductCategorySection
                title={"Cost-Effective"}
                content={
                  <>
                    Extrusion Product are affordable to produce and install,
                    reducing overall system costs.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog2.webp"}
              />

              <section className="upvc_benefit_section">
                <div
                  style={{
                    width: "max-content",
                    margin: "auto",
                    padding: "2rem 0",
                  }}
                >
                  <MainHeading title={"Benefits of Metal Tubes"} />
                </div>

                <RightImagesTextcard
                  orangeheading={"Energy"}
                  title=" -  & Resource Savings"
                  content={
                    <>
                      Lightweight design reduces transport and handling costs,
                      and its low friction ensures efficient fluid flow.{" "}
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog5.jpg"}
                />
                <LeftImagesTextCard
                  orangeheading={"Low Maintenance"}
                  title={"and Durability"}
                  content={
                    <>
                      Highly resistant to corrosion, chemicals, and wear, nylon
                      tubes require minimal maintenance and have a long service
                      life.
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog4.jpg"}
                />
                <RightImagesTextcard
                  orangeheading={"Enhanced"}
                  title=" - Safety"
                  content={
                    <>
                      Non-toxic, abrasion-resistant, and flexible, nylon tubes
                      reduce risks of leaks, breakages, or system failures.{" "}
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog3.jpg"}
                />
                <LeftImagesTextCard
                  orangeheading={"Operational"}
                  title={"Efficiency"}
                  content={
                    <>
                      Smooth inner surfaces and excellent dimensional stability
                      ensure consistent performance under pressure, temperature,
                      and vibration.{" "}
                    </>
                  }
                  imageurl={"/assets/images/new_images/blogs/blog1.jpg"}
                />
              </section>
            </>
          ) : (
            ""
          )}

          {slug === "metal-tube-bending-and-assy" ? (
            <>
              <WhyProductCategorySection
                title={"Cost-Effective"}
                content={
                  <>
                    Durable materials and precise manufacturing reduce
                    replacement frequency and long-term operational costs.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/industrial-metal-drill-machine-metalworking-workshop_342744-520.jpg"
                }
              />
              <div
                style={{
                  margin: "auto",
                  padding: "2rem 0",
                  textAlign: "center",
                }}
              >
                <MainHeading title={"Benefits of Nylon Tube Assemblies"} />
              </div>
              <RightImagesTextcard
                orangeheading="Energy "
                title="& Resource Savings"
                content={
                  <>
                    High strength-to-weight ratio and optimized design minimize
                    material use while maintaining performance
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/istockphoto-457740707-612x612.jpg"
                }
              />
              <LeftImagesTextCard
                orangeheading={"Low"}
                title={"Maintenance"}
                content={
                  <>
                    Resistant to wear, pressure, and temperature fluctuations,
                    requiring minimal inspection and upkeep.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/harvesters-combine-parts-plant-are-waiting-sales_146671-19060.jpg"
                }
              />
              <RightImagesTextcard
                orangeheading={"Enhanced"}
                title="Safety"
                content={
                  <>
                    Robust construction and reliable fittings prevent leaks,
                    bursts, and operational hazards.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/industrial-metal-drill-machine-metalworking-workshop_342744-520.jpg"
                }
              />
              <LeftImagesTextCard
                orangeheading={"Operational"}
                title={"Efficiency"}
                content={
                  <>
                    Precision-engineered assemblies ensure consistent flow, easy
                    installation, and compatibility with complex systems.
                  </>
                }
                imageurl={
                  "/assets/images/new_images/recent_project/download.jpeg"
                }
              />
            </>
          ) : (
            ""
          )}

          {slug === "others" ? (
            <>
              <WhyProductCategorySection
                title={"Cost-Effective"}
                content={
                  <>
                    Affordable material and simple application reduce labor and
                    replacement costs.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog5.jpg"}
              />
              <div
                style={{
                  margin: "auto",
                  padding: "2rem 0",
                  textAlign: "center",
                }}
              >
                <MainHeading title={"Benefits of Manufacturing"} />
              </div>
              <RightImagesTextcard
                orangeheading={"Energy"}
                title="& Resource Savings"
                content={
                  <>
                    Lightweight and easy to install, minimizing time and
                    material waste.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog1.jpg"}
              />
              <LeftImagesTextCard
                orangeheading={"Low"}
                title={"Maintenance"}
                content={
                  <>
                    Resistant to moisture, chemicals, abrasion, and UV,
                    requiring minimal upkeep.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog2.webp"}
              />
              <RightImagesTextcard
                orangeheading={"Enhanced "}
                title="Safety"
                content={
                  <>
                    Provides electrical insulation, protects against short
                    circuits, mechanical damage, and environmental exposure.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog3.jpg"}
              />
              <LeftImagesTextCard
                orangeheading={"Operational "}
                title={"Efficiency"}
                content={
                  <>
                    Ensures reliable connections, neat assemblies, and long-term
                    durability.
                  </>
                }
                imageurl={"/assets/images/new_images/blogs/blog4.jpg"}
              />
            </>
          ) : (
            ""
          )}

          <div style={{ height: "3rem" }}></div>
        </>
      )}

      <Footer />
    </>
  );
};
export { HomeInterior };
